<template>
  <div class="section-title">
    <div class="title-wrapper">
      <div class="title">
        {{ $isCN() ? title : titleEN }}
        <div class="bg"></div>
      </div>
      <div class="title-en" v-if="$isCN()">{{ titleEN }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    titleEN: String,
  },
};
</script>

<style lang="less" scoped>
.section-title {
  align-self: center;
  position: relative;
  z-index: 2;
}
.title-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 28px;
  color: #2b2c2e;
  position: relative;
  flex-shrink: 0;
  text-transform: capitalize;

  .bg {
    background: #ff571a;
    width: 31px;
    height: 19px;
    position: absolute;
    bottom: -6px;
    right: -15px;
    opacity: 0.7;
    z-index: -1;
  }

  &-en {
    font-weight: 300;
    font-size: 20px;
    line-height: 28px;
    text-transform: capitalize;
    color: #b4b5b7;
    margin-top: 11px;
  }
}

.ph,
.icon-right,
.all-btn {
  display: none;
}

@media screen and (max-width: 540px) {
  .ph,
  .icon-right,
  .all-btn {
    display: initial;
    flex-shrink: 0;
  }

  .title-wrapper {
    width: 100%;
  }
  .section-title {
    align-self: unset;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    width: 100%;

    .ph {
      flex: 1;
    }

    .icon-right {
      width: 16px;
      height: 16px;
    }
    .all-btn {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #ff571a;
    }
  }

  .title {
    font-size: 16px;

    .bg {
      width: 15px;
      height: 10px;
      bottom: 2px;
      right: -5px;
    }

    &-en {
      margin-top: 2px;
      font-size: 10px;
      line-height: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionTitle.vue